import { render, staticRenderFns } from "./SmsManagement.vue?vue&type=template&id=8a0db18a&scoped=true&"
import script from "./SmsManagement.vue?vue&type=script&lang=js&"
export * from "./SmsManagement.vue?vue&type=script&lang=js&"
import style0 from "./SmsManagement.vue?vue&type=style&index=0&id=8a0db18a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0db18a",
  null
  
)

export default component.exports